var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"__ProgressBarChart"},[_vm._t("head-content"),_c('div',{style:({ width: '100%', height: _vm.height }),attrs:{"id":(_vm.name + "-div")}}),_vm._t("foot-content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }